import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { when } from "lit/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let PromotionalHeader = class extends InternalElement {
  constructor() {
    super(...arguments);
    this.showRecommendedTag = false;
  }
  render() {
    var _a, _b;
    return html`
      <div id="promotional-header">
        <h1 style=${styleMap({ flex: this.showRecommendedTag ? "unset" : 1 })}>
            ${((_a = this.quote) == null ? void 0 : _a.product.promotional_header) || ((_b = this.quote) == null ? void 0 : _b.product.friendly_name)}
        </h1>
        ${when(this.showRecommendedTag, () => html`
          <div id="offer-tag-wrapper">
            <div id="offer-tag">Recommended</div>
          </div>
        `)}
        <slot></slot>
      </div>
    `;
  }
};
PromotionalHeader.styles = css`
    #promotional-header {
      display: flex;
      align-items: center;
      --default-vi-font-xl: var(--vi-multi-offer-header-font-size);
    }

    h1 {
      font-size: var(--vi-multi-offer-header-font-size);
      font-weight: var(--default-vi-promotional-header-font-weight);
      font-family: var(--default-vi-promotional-header-font-family);
      color: var(--default-vi-promotional-header-color);
      margin: 0;
    }

    slot {
      font-size: var(--default-vi-font-xl);
      font-weight: bold;
    }


    @media (max-width: 700px) {
      #offer-header {
        flex-direction: column;
        gap: var(--default-vi-offer-header-spacing);
      }

      #promotional-description {
        min-height: 68px;
      }

      #promotional-header {
        align-items: center;
        gap: 10px;
      }
    }

    #offer-tag-wrapper {
      display: flex;
      align-items: flex-start;
      flex: 1;
    }

    #offer-tag {
      font-size: var(--default-vi-font-sm);
      font-weight: bold;
      color: var(--default-vi-tag-contrast-color);
      background: var(--default-vi-tag-color);
      padding: 5px 15px;
      text-align: center;
      border-radius: 8px;
      display: var(--default-vi-tag-display);
    }

    @media (max-width: 700px) {
      slot {
        font-size: unset;
        font-weight: unset;
      }
    }

    @container (max-width: 800px) {
      #offer-header {
        flex-direction: column;
        gap: var(--default-vi-offer-header-spacing);
      }

      #promotional-description {
        min-height: 68px;
      }

      #promotional-header {
        align-items: center;
      }
    }
  `;
__decorateClass([
  property({ attribute: "fallback" })
], PromotionalHeader.prototype, "fallback", 2);
__decorateClass([
  property({ type: Boolean })
], PromotionalHeader.prototype, "showRecommendedTag", 2);
PromotionalHeader = __decorateClass([
  customElement("promotional-header")
], PromotionalHeader);
export {
  PromotionalHeader
};
